import { isAgentsEmbed } from '@/lib/agents-embed';
import { AgentsEmbedLayout } from './agents-embed-layout';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import { useFlag } from '@/contexts/flags-context';
import { applyAgentBetaTheme, readAgentBetaThemeMode } from '@/lib/agent-beta-theme';
import { TopNav } from '@/components/top-nav';
import { SideNav } from '@/components/side-nav';
import { CommandPalette } from '@/components/command-palette';
import { FeedbackWidget } from '@/components/feedback-widget';
import './agent-workspace-theme.css';

export function AppLayout() {
  return isAgentsEmbed() ? <AgentsEmbedLayout /> : <FullAppLayout />;
}

function FullAppLayout() {
  const betaTheme = useFlag('agent-beta-theme');
  const mainRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    applyAgentBetaTheme(betaTheme, readAgentBetaThemeMode());
    return () => applyAgentBetaTheme(false, 'dark');
  }, [betaTheme]);

  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      if (el.scrollTop > el.scrollHeight - el.clientHeight) {
        el.scrollTop = Math.max(0, el.scrollHeight - el.clientHeight);
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col">
      <TopNav />
      <div className="flex flex-1 min-h-0">
        <SideNav />
        <main ref={mainRef} className="flex-1 min-w-0 min-h-0 overflow-y-auto scroll-smooth">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <FeedbackWidget />
    </div>
  );
}
